import CuteImg from '../pages/ChugumiTest/Cute.png';
import CoolImg from '../pages/ChugumiTest/Cool.png';
import MasculineImg from '../pages/ChugumiTest/Masculine.png';
import SoftImg from '../pages/ChugumiTest/Soft.png';
import ClassicImg from '../pages/ChugumiTest/Classic.png';
import PracticalImg from '../pages/ChugumiTest/Practical.png';
import UniqueImg from '../pages/ChugumiTest/Unique.png';
import ArtisticImg from '../pages/ChugumiTest/Artistic.png';

// 16가지 추구미 결과 데이터 (4x4 매트릭스)
export const CHUGUMI_RESULTS = {
    "Cuteness_Practical": { "key": "Cuteness_Practical", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": CuteImg },
    "Cuteness_Classic": { "key": "Cuteness_Classic", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": ClassicImg },
    "Cuteness_Artistic": { "key": "Cuteness_Artistic", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": ArtisticImg },
    "Cuteness_Unique": { "key": "Cuteness_Unique", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": UniqueImg },
    "Softness_Practical": { "key": "Softness_Practical", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": SoftImg },
    "Softness_Classic": { "key": "Softness_Classic", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": ClassicImg },
    "Softness_Artistic": { "key": "Softness_Artistic", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": ArtisticImg },
    "Softness_Unique": { "key": "Softness_Unique", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": UniqueImg },
    "Coolness_Practical": { "key": "Coolness_Practical", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": PracticalImg },
    "Coolness_Classic": { "key": "Coolness_Classic", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": CoolImg },
    "Coolness_Artistic": { "key": "Coolness_Artistic", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": ArtisticImg },
    "Coolness_Unique": { "key": "Coolness_Unique", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": UniqueImg },
    "Masculine_Practical": { "key": "Masculine_Practical", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": MasculineImg },
    "Masculine_Classic": { "key": "Masculine_Classic", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": MasculineImg },
    "Masculine_Artistic": { "key": "Masculine_Artistic", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": ArtisticImg },
    "Masculine_Unique": { "key": "Masculine_Unique", "title": "", "summary": "", "style": "", "hashtags": [], "character": "", "image": UniqueImg }
};

// 점수 계산 함수
export const calculateChugumiResult = (answers) => {
    // answers: { questionId: scoreValue(1-5) }

    let vibeScore = 0;
    let identityScore = 0;

    // Vibe 축 계산 (문항 1-8)
    // 문항 1은 역채점
    vibeScore += (6 - answers[1]); // 역채점: 5->1, 4->2, 3->3, 2->4, 1->5
    for (let i = 2; i <= 8; i++) {
        vibeScore += answers[i] || 3; // 답변 없으면 중립값 3
    }

    // Identity 축 계산 (문항 9-16)
    // 문항 9는 역채점
    identityScore += (6 - answers[9]); // 역채점
    for (let i = 10; i <= 16; i++) {
        identityScore += answers[i] || 3;
    }

    // Vibe 분류 (8-40점 범위)
    let vibeCategory;
    if (vibeScore >= 8 && vibeScore <= 16) {
        vibeCategory = "Cuteness";
    } else if (vibeScore >= 17 && vibeScore <= 24) {
        vibeCategory = "Softness";
    } else if (vibeScore >= 25 && vibeScore <= 32) {
        vibeCategory = "Coolness";
    } else {
        vibeCategory = "Masculine"; // 33-40
    }

    // Identity 분류 (8-40점 범위)
    let identityCategory;
    if (identityScore >= 8 && identityScore <= 16) {
        identityCategory = "Practical";
    } else if (identityScore >= 17 && identityScore <= 24) {
        identityCategory = "Classic";
    } else if (identityScore >= 25 && identityScore <= 32) {
        identityCategory = "Artistic";
    } else {
        identityCategory = "Unique"; // 33-40
    }

    // 최종 결과 키
    const resultKey = `${vibeCategory}_${identityCategory}`;

    return {
        resultKey,
        vibeScore,
        identityScore,
        vibeCategory,
        identityCategory,
        result: CHUGUMI_RESULTS[resultKey]
    };
};
